// extracted by mini-css-extract-plugin
export default {"body":"Navbar_body__mMQza","title":"Navbar_title__ds4O0"};